<template>
  <div class="w-full lg:max-w-full lg:flex px-1 pb-1" @click.stop="notificationRead(notification)">
    <div
      class="bg-white rounded-sm p-4 flex flex-col justify-between
      leading-normal w-screen border-b border-gray-300"
      :class="{ 'font-bold bg-indigo-100': !isRead}"
    >
      <button class="flex justify-end pr-2 pt-1 w-6 pb-3"
        @click.stop="deleteNotification(notification.id)">
        <close-icon class="w-2 text-gray-600"/>
      </button>
      <div>
        <keep-alive>
          <component
            class="text-gray-700 text-base"
            :is="notificationComponent"
            :notification="notification"
          ></component>
        </keep-alive>
      </div>
      <div class="pt-3 flex justify-end opacity-60">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4" :class="{ 'read': isRead}"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M182.6 246.6C170.1 259.1 149.9 259.1 137.4 246.6L57.37 166.6C44.88 154.1 44.88 133.9 57.37 121.4C69.87 108.9 90.13 108.9 102.6 121.4L159.1 178.7L297.4 41.37C309.9 28.88 330.1 28.88 342.6 41.37C355.1 53.87 355.1 74.13 342.6 86.63L182.6 246.6zM182.6 470.6C170.1 483.1 149.9 483.1 137.4 470.6L9.372 342.6C-3.124 330.1-3.124 309.9 9.372 297.4C21.87 284.9 42.13 284.9 54.63 297.4L159.1 402.7L393.4 169.4C405.9 156.9 426.1 156.9 438.6 169.4C451.1 181.9 451.1 202.1 438.6 214.6L182.6 470.6z"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from '@/components/notifications/Notification.vue';
import LessonHasBeenCanceledNotification from '@/components/notifications/LessonHasBeenCanceledNotification.vue';
import YouHaveCanceledLessonNotification from '@/components/notifications/YouHaveCanceledLessonNotification.vue';
import LessonHasBeenBookedNotification from '@/components/notifications/LessonHasBeenBookedNotification.vue';
import YouHaveBookedLessonNotification from '@/components/notifications/YouHaveBookedLessonNotification.vue';
import StudentAcceptedNewLessonTimeNotification from '@/components/notifications/StudentAcceptedNewLessonTimeNotification.vue';
import StudentRefusedNewLessonTimeNotification from '@/components/notifications/StudentRefusedNewLessonTimeNotification.vue';
import TeacherHasStartedLessonNotification from '@/components/notifications/TeacherHasStartedLessonNotification.vue';
import TeacherNeedToChangeLessonNotification from '@/components/notifications/TeacherNeedToChangeLessonNotification.vue';
import CloseIcon from '@/components/graphics/CloseIcon.vue';

import { mapActions } from 'vuex';

export default {
  components: {
    Notification,
    LessonHasBeenCanceledNotification,
    YouHaveCanceledLessonNotification,
    LessonHasBeenBookedNotification,
    YouHaveBookedLessonNotification,
    StudentAcceptedNewLessonTimeNotification,
    StudentRefusedNewLessonTimeNotification,
    TeacherHasStartedLessonNotification,
    TeacherNeedToChangeLessonNotification,
    CloseIcon,
  },
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    notificationComponent() {
      // the regex match the string after the last backslash. In this case the Notification Type
      return this.notification ? this.notification.type.match(/[^/\\]+$/)[0] : null;
    },
    isRead() {
      return this.notification ? this.notification.read_at : false;
    },
  },
  methods: {
    ...mapActions('notifications', [
      'markAsRead',
      'delete',
    ]),
    notificationRead(notification) {
      this.markAsRead(notification);
    },
    deleteNotification(id) {
      this.delete(id);
    },
  },
};
</script>

<style scoped>
  .read {
    stroke: rgb(16, 169, 16);
    fill: rgb(39, 176, 39);
  }
</style>
